var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0699,
    cy: 37.7025,
    r: 36.5521,
    fill: "#5BBAB9",
    stroke: "#D4D4D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEllipse);
export default __webpack_public_path__ + "static/media/greenEllipse.f600c9e4d90a8caf2d6d70a6f0042120.svg";
export { ForwardRef as ReactComponent };